import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';

import { CadastrarTipoReuniaoComponent } from './cadastrar-tipo-reuniao/cadastrar-tipo-reuniao.component';
import { TipoReuniaoRoutingModule } from './tipo-reuniao-routing.module';
import { TipoReuniaoComponent } from './tipo-reuniao.component';


@NgModule({
  declarations: [
    TipoReuniaoComponent,
    CadastrarTipoReuniaoComponent
  ],
  imports: [
    CommonModule,
    MaterialCommonModule,
    TipoReuniaoRoutingModule
  ]
})
export class TipoReuniaoModule { }
